export const parsePostalCode = (value) =>
  value.replace(/^\s+|\s+$|\s+(?=\s)/g, '').trim();
